import http from './http'
import Config from '../profiles';

export const exportpdf = (request, config) => {
    return http.post(Config.getAdminServiceURL+`/v1/export/pdf`, request, config);
};